import { useCallback, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../../FJModal';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTTVLibraryModal from '../view/FJTTVLibraryModal.jsx';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';
import FJActionVoiceCloning from '../../../../redux/action/FJActionVoiceCloning.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJTextToSpeechUtil from '../../../../util/FJTextToSpeechUtil.js';

const FJTTVLibraryModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const isShowLibraryModal = useSelector(state => state.textToSpeech.isShowLibraryModal);
    const voiceInfo = useSelector(state => state.textToSpeech.voiceInfo);
    const favoriteList = useSelector(state => state.textToSpeech.favoriteList);
    const voiceCloneList = useSelector(state => state.common.historyList);
    const languageList = useSelector(state => state.textToSpeech.languageList);
    const languageValue = useSelector(state => state.textToSpeech.languageValue);
    const createCloneStatus = useSelector(state => state.voiceCloning.createCloneStatus);
    const loadingFavoriteListStatus = useSelector(state => state.textToSpeech.loadingFavoriteListStatus);

    const [tabIndex, setTabIndex] = useState(0);

    const voiceList = useMemo(() => {
        return FJTextToSpeechUtil.getVoiceListByLanguage(voiceInfo, languageList, languageValue);
    }, [voiceInfo, languageValue, languageList]);

    const favoriteVoiceList = useMemo(() => {
        return FJTextToSpeechUtil.getFavoriteVoiceListByIds(voiceInfo, favoriteList);
    }, [voiceInfo, favoriteList]);

    const onClose = useCallback(() => {
        dispatch(FJActionTextToSpeech.hideLibraryModalAction());
    }, [dispatch]);

    const _onUse = info => {
        dispatch(FJActionTextToSpeech.useVoiceItemAction(info, { fromType: info.fromType }));
    };

    const _onLanguageValueChange = value => {
        dispatch(FJActionTextToSpeech.setSliceSpeechLanguageValueAction(value));
    };

    const _getFavorite = () => {
        dispatch(FJActionTextToSpeech.getFavoriteAction());
    };

    const _toCreateClone = () => {
        dispatch(FJActionVoiceCloning.setCreateCloneStatusAction(FJConstant.DEFAULT));
    };

    return (
        <FJModal visible={isShowLibraryModal}>
            <FJTTVLibraryModal
                onClose={onClose}
                voiceList={voiceList}
                favoriteVoiceList={favoriteVoiceList}
                voiceCloneList={voiceCloneList}
                onUse={_onUse}
                languageList={languageList}
                onLanguageValueChange={_onLanguageValueChange}
                languageValue={languageValue}
                tabIndex={tabIndex}
                setTabIndex={setTabIndex}
                loadingFavoriteListStatus={loadingFavoriteListStatus}
                getFavorite={_getFavorite}
                toCreateClone={_toCreateClone}
                createCloneStatus={createCloneStatus}
            />
        </FJModal>
    );
};
export default FJTTVLibraryModalContainer;
